import { BaseElement, defineElement } from '@webtides/element-js';

const convertStringToHTML = (template) => {
    const parser = new DOMParser();
    const document = parser.parseFromString(template.toString(), 'text/html');
    return document.body;
};

/**
 * @property {string} seenRecentlyPageId
 */
export default class SeenRecentlyTeaserComponent extends BaseElement {
    properties() {
        return {
            seenRecentlyPageId: undefined,
        };
    }

    connected() {
        if (!this.seenRecentlyPageId) {
            const visitedPages = JSON.parse(window.localStorage.getItem('visitedPages')) || [];
            if (visitedPages.length > 0) {
                this.seenRecentlyPageId = visitedPages[visitedPages.length - 1];
                this.fetchComponent();
            }
        }
    }

    fetchComponent() {
        fetch(`${this.contentPath}?seenRecentlyPageId=${this.seenRecentlyPageId}`)
            .then((result) => result.text())
            .then((htmlString) => {
                const html = convertStringToHTML(htmlString);
                const container = html.querySelector('seen-recently-teaser-component');
                this.replaceChildren(...container.childNodes);
            });
    }
}

defineElement('seen-recently-teaser-component', SeenRecentlyTeaserComponent);
